import React, { useRef, useState } from 'react';
import ModalBoxPopup from './ModalBoxPopup';
import Zoomproduct from '../Component/Zoomproduct';

function GridListingData({
  Modal,
  show,
  handleClose,
  Button,
  Product = [],
  currentIndex: initialIndex = 0,
}) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [detailModalShow, setDetailModalShow] = useState(false);
  const [zoomModalShow, setZoomModalShow] = useState(false);

  const thumbnailRef = useRef(null); // 👈 for horizontal scroll container

  const currentImage = Product[currentIndex] || null;

  const handleImageClick = () => setDetailModalShow(true);
  const handleDetailModalClose = () => setDetailModalShow(false);
  const handleZoomClick = () => setZoomModalShow(true);
  const handleZoomClose = () => setZoomModalShow(false);

  const handlePrev = () => {
    if (currentIndex > 0) setCurrentIndex(currentIndex - 1);
  };

  const handleNext = () => {
    if (currentIndex < Product.length - 1) setCurrentIndex(currentIndex + 1);
  };

  const handleThumbnailClick = (index) => setCurrentIndex(index);

  // 👇 Scroll thumbnails left/right
  const scrollThumbnails = (direction) => {
    if (thumbnailRef.current) {
      const scrollAmount = 150; // adjust scroll speed
      thumbnailRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth',
      });
    }
  };

  return (
    <>
      {/*-------- Main Image Viewer Modal --------*/}
      <Modal show={show} onHide={handleClose} fullscreen centered>
        <Modal.Body className="text-center p-0">
          {/*------ Close Button --------*/}
          <Button
            variant="light"
            onClick={handleClose}
            className="position-absolute top-0 end-0 close-btns"
            style={{ zIndex: 1050 }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>

          {/*--------- Main Image Section ------*/}
          <div className="modal-image-container-BOX d-flex justify-content-center align-items-center">
            <Button
              className="bg-transparent border-0"
              variant="secondary"
              onClick={handlePrev}
              disabled={currentIndex === 0}
              style={{ fontSize: '13px', padding: '2px 8px' }}
            >
              <i className="bi bi-chevron-left"></i>
            </Button>

            <div style={{ position: 'relative', maxWidth: '100%' }}>
              <h3 className="text-xl text-gray-500 mt-0 mb-2">
                AFROZ 0001 <span className="text-green-600"> 234 </span>
              </h3>

              {currentImage ? (
                <>
                  <img
                    src={currentImage}
                    alt="Preview"
                    className="w-100"
                    style={{
                      borderRadius: '10px',
                      cursor: 'pointer',
                      objectFit: 'contain',
                      maxHeight: '70vh',
                    }}
                    onClick={() => {
                      if (window.innerWidth <= 768) {
                        window.location.href = '/mobileGrid';
                      } else {
                        handleImageClick();
                      }
                    }}
                  />
                  {/*------- Zoom Icon -------*/}
                  <span
                    className="zoomicon position-absolute"
                    onClick={handleZoomClick}
                    style={{
                      cursor: 'pointer',
                      top: '45px',
                      right: '25px',
                      fontSize: '14px',
                      background: '#fff',
                      borderRadius: '50%',
                      padding: '4px 8px',
                      boxShadow: '0 2px 5px rgba(0,0,0,0.2)',
                    }}
                  >
                    <i className="bi bi-zoom-in"></i>
                  </span>
                </>
              ) : (
                <p> No image available </p>
              )}

              {/*------- Thumbnail Scroll Section -------*/}
              <div className="d-flex align-items-center justify-content-center mt-3">
                {/*-------- Left Scroll Button ------*/}
                <Button
                  className="bg-transparent border-0"
                  onClick={() => scrollThumbnails('left')}
                  style={{
                    fontSize: '14px',
                    padding: '2px 8px',
                    boxShadow: 'none',
                  }}
                >
                  <i className="bi bi-chevron-left"></i>
                </Button>

                <div
                  ref={thumbnailRef}
                  className="thumbnail-scroll d-flex align-items-center"
                  style={{
                    overflowX: 'hidden',
                    scrollBehavior: 'smooth',
                    whiteSpace: 'nowrap',
                    gap: '10px',
                    paddingBottom: '10px',
                    maxWidth: '70%',
                  }}
                >
                  {Product?.map((img, index) => (
                      <img
                        key={index}
                        src={img}
                        alt={`Thumbnail-${index}`}
                        onClick={() => handleThumbnailClick(index)}
                        style={{
                          width: '70px',
                          height: '70px',
                          borderRadius: '6px',
                          marginRight: '8px',
                          cursor: 'pointer',
                          border:
                            index === currentIndex
                              ? '2px solid #28a745'
                              : '2px solid transparent',
                          transition: 'border 0.3s ease',
                          objectFit: 'cover',
                        }}
                      />
                    ))}
                </div>
                {/*--------- Right Scroll Button --------*/}
                <Button
                  className="bg-transparent border-0"
                  onClick={() => scrollThumbnails('right')}
                  style={{
                    fontSize: '14px',
                    padding: '2px 8px',
                    boxShadow: 'none',
                  }}
                >
                  <i className="bi bi-chevron-right"></i>
                </Button>
              </div>
            </div>

            <Button
              className="bg-transparent border-0"
              variant="secondary"
              onClick={handleNext}
              disabled={currentIndex === Product.length - 1}
              style={{ fontSize: '13px', padding: '2px 8px' }}
            >
              <i className="bi bi-chevron-right"></i>
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      {/*------------ Second Detail Modal --------*/}
      <ModalBoxPopup
        Modal={Modal}
        detailModalShow={detailModalShow}
        handleDetailModalClose={handleDetailModalClose}
        Button={Button}
        currentImage={currentImage}
      />

      {/*------------ Zoom Modal --------------*/}
      <Zoomproduct
        show={zoomModalShow}
        onHide={handleZoomClose}
        currentImage={currentImage}
      />
    </>
  );
}
export default GridListingData;
